import Vue from "vue";

export const scrollbarDirective = {
  /**
   * @param {HTMLElement} el
   * @param {Object} binding
   * @param {Vue} vnode
   *
   * Watches for the presence of a scrollbar on the element and updates the
   * given data property with a boolean value indicating whether the scrollbar
   * is present.
   *
   * @example
   * <div v-scrollbar:hasScrollbar="hasScrollbar">
   *   <!-- content -->
   * </div>
   */
  bind(el, binding, vnode) {
    el._scrollbarObserver = null;

    const vm = vnode.context;
    const expression = binding.expression;

    const checkScrollbar = () => {
      requestAnimationFrame(() => {
        if (
          !vm ||
          !expression ||
          !Object.prototype.hasOwnProperty.call(vm, expression)
        ) {
          return;
        }

        const hasScrollbar = el.scrollHeight > el.clientHeight;
        vm[expression] = hasScrollbar;
      });
    };

    el._scrollbarObserver = new ResizeObserver(checkScrollbar);
    el._scrollbarObserver.observe(el);

    checkScrollbar();
  },

  unbind(el) {
    if (el._scrollbarObserver) {
      el._scrollbarObserver.disconnect();
      el._scrollbarObserver = null;
    }
  },
};

Vue.directive("scrollbar", scrollbarDirective);
